import React, { useRef, useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import "../../Styles/Styles/dashboardstyle.css";

import rightImage from "../../Assets/img/test.png";
// import Logo from "../../Assets/img/paperboylogo.png";
import Logo from "../../Assets/img/the-paperboy-logo-5.png";

import axios from "axios";
import { useFormik } from "formik";
import * as Yup from "yup";
import { BASE_URL, security_key } from "../../global";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import "react-phone-input-2/lib/bootstrap.css";
import "react-phone-input-2/lib/high-res.css";
// import "react-phone-input-2/lib/material.css";

import LinearProgress from "@mui/material/LinearProgress";

const Member_Register = () => {
    const navigate = useNavigate();

    const formRef = useRef(null);

    const [isSubmitting, setIsSubmitting] = useState(false);

    const [showPassword, setShowPassword] = useState(false);

    const toggleShowPassword = () => {
        setShowPassword(!showPassword);
    };

    const reverseString = (str) => {
        return str.split("").reverse().join("");
    };

    const referralcode = sessionStorage.getItem("referral_code");

    const getTrialDates = () => {
        const start = new Date();
        const end = new Date();
        end.setMonth(end.getMonth() + 1);

        const formatDate = (date) => {
            const year = date.getFullYear();
            const month = String(date.getMonth() + 1).padStart(2, "0");
            const day = String(date.getDate()).padStart(2, "0");
            return `${year}-${month}-${day}`;
        };

        return {
            trial_start_date: formatDate(start),
            trial_end_date: formatDate(end),
        };
    };

    const { trial_start_date, trial_end_date } = getTrialDates();

    const initialValues = {
        first_name: "",
        last_name: "",
        phone: "",
        user_name: "",
        user_email: "",
        password: "",
        referral_code: referralcode ? reverseString(referralcode) : "",
        user_type: 3,
        user_status: 0,
        trial_start_date,
        trial_end_date,
    };

    const basicSchema = Yup.object().shape({
        first_name: Yup.string()
            // .min(3, "First Name must be at least 3 characters.")
            .max(50, "First Name must be at most 50 characters.")
            .matches(/^[a-zA-Z]*$/, "Only letters allowed.")
            .required("First Name is required."),

        last_name: Yup.string()
            .min(1, "Last Name must be at least 1 character.")
            .max(50, "Must be atmost 50 characters.")
            .matches(/^[a-zA-Z]*$/, "Only letters allowed.")
            .required("Last Name is required."),

        referral_code: Yup.string()
            .length(16, "Referral Code must be exactly 16 characters.")
            .matches(/^[a-zA-Z0-9]*$/, "Referral Code can only contain letters and numbers.")
            // .required("Referral Code is required.")
            .test("unique-link", "Invalid referral code", async function (value) {
                if (!value) return true;
                return await checkReferralCode(value);
            }),

        user_name: Yup.string()
            .required("Username is required.")
            // .matches(
            //     /^[a-zA-Z][a-zA-Z0-9_]{2,19}$/,
            //     "Username must be 3-20 characters long, start with a letter, and can only contain letters, numbers, and underscores."
            // )
            .test("startWithLetter", "Username must start with a letter.", (value) => value && /^[a-zA-Z]/.test(value))
            .test("validCharacters", "Only letters, numbers, or underscores allowed.", (value) => value && /^[a-zA-Z0-9_]+$/.test(value))
            .test("length", "Username must be 3-20 characters long.", (value) => value && value.length >= 3 && value.length <= 20)
            .matches(/^(?!.*__)/, "Consecutive underscores not allowed.")
            .test("unique-link", "Username taken. Please choose another.", async function (value) {
                if (!value) return true;
                const isUserNameUnique = await checkUserName(value);
                return isUserNameUnique;
            }),

        user_email: Yup.string()
            .email("Invalid email address.")
            .required("Email is required.")
            .test("valid-domain", "Invalid domain format.", function (value) {
                const domainPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
                return domainPattern.test(value || "");
            })
            .test("unique-link", "User Email already exists", async function (value) {
                if (!value) return true;
                const isUserEmailUnique = await checkUserEmail(value);
                return isUserEmailUnique;
            }),

        password: Yup.string()
            .min(8, "Password must be at least 8 characters.")
            .max(100, "Password must be at most 100 characters.")
            .matches(/[a-zA-Z]/, "Password must contain at least one letter.")
            .matches(/\d/, "Password must contain at least one number.")
            .matches(/[@$!%*?&#]/, "Password must contain at least one special character.")
            .required("Password is required."),

        phone: Yup.string()
            .required("Phone number is required.")
            .min(11, "Phone number must be at least 10 digits.")
            .max(16, "Phone number must not exceed 15 digits.")
            .test("unique-digits", "Invalid phone number.", function (value) {
                const cleanedDigits = value.replace(/^\+\D*/, "");
                const digitsWithoutCountryCode = cleanedDigits.slice(1);
                const hasDifferentDigit = Array.from(new Set(digitsWithoutCountryCode)).length !== 1;
                return hasDifferentDigit || this.createError({ message: "Invalid phone number." });
            }),
    });

    async function checkUserName(user_name) {
        const response = await axios.post(BASE_URL + "API/apicall", {
            security_key: security_key,
            mode: "checkUserName",
            user_name: user_name,
        });

        const output = response.data;

        return output == 1 ? false : true;
    }

    async function checkUserEmail(user_email) {
        const response = await axios.post(BASE_URL + "API/apicall", {
            security_key: security_key,
            mode: "checkUserEmail",
            user_email: user_email,
        });

        const output = response.data;

        return output == 1 ? false : true;
    }

    async function checkReferralCode(referral_code) {
        const response = await axios.post(BASE_URL + "API/apicall", {
            security_key: security_key,
            mode: "checkReferralCode",
            referral_code: referral_code,
        });

        const output = response.data;

        return output == 1 ? true : false;
    }

    const formik = useFormik({
        initialValues,
        validationSchema: basicSchema,
        enableReinitialize: true,
        onSubmit: async (formValues) => {
            toast.dismiss();

            setIsSubmitting(true);

            const response = await axios.post(
                BASE_URL + "API/apicall",
                {
                    security_key: security_key,
                    mode: "userRegister1",
                    ...formValues,
                },
                {
                    headers: {
                        "Content-Type": "multipart/form-data",
                    },
                }
            );

            const output = response.data;
            if (output == 1) {
                toast.success("You have successfully signed up", {
                    autoClose: 3000,
                });

                sendVerificationCode(formValues.user_email);
            } else {
                toast.error("Invalid email or password.", {
                    autoClose: 3000,
                });
            }
            setTimeout(function () {
                setIsSubmitting(false);
            }, 3000);
        },
    });

    const togglePasswordVisibility = () => {
        setShowPassword(!showPassword);
    };
    // Now, you can set variables as needed:
    const values = formik.values;
    const handleBlur = formik.handleBlur;
    const touched = formik.touched;
    const handleChange = formik.handleChange;
    const errors = formik.errors;
    const handleSubmit = formik.handleSubmit;
    const setFieldValue = formik.setFieldValue;
    const setTouched = formik.setTouched;
    const resetForm = formik.resetForm;
    const setValues = formik.setValues;
    const handleReset = formik.handleReset;

    useEffect(() => {
        // sendVerificationCode("wobunih@mailinator.com");
        // upgradeUserLevel();
    }, []);

    const sendVerificationCode = async (user_email) => {
        const response = await axios.post(BASE_URL + "API/apicall", {
            security_key: security_key,
            mode: "sendVerificationCode",
            user_email: user_email,
        });

        const output = response.data;

        if (output == 1) {
            navigate("/verify", { state: { user_email: user_email } });
        }
    };
    const upgradeUserLevel = async () => {
        const response = await axios.post(BASE_URL + "API/apicall", {
            security_key: security_key,
            mode: "upgradeUserLevel",
            // user_key: "2F5460D7B8D75AC6",
            user_key: "5A649A04FF8E034A",
        });

        const output = response.data;
    };
    return (
        <>
            <ToastContainer position="top-center" />
            <section className="site-main">
                <div className="container vh-100 my-5 d-flex justify-content-center align-items-center">
                    <div className="site-sub-main bg-white site-reg-main">
                        <div className="field d-none d-lg-block bg-1">
                            <div className="wrapper">
                                <div className="sub-wrapp d-flex align-items-center justify-content-center mt-5">
                                    <div className="text-box-right text-start p-4 ">
                                        <h6>Hello,</h6>
                                        <h2 className="fw-bold fs-3">Welcome!</h2>
                                        <p className="mb-1">Create your account</p>
                                    </div>
                                </div>
                                <div className="sub-wrapp">
                                    <img src={rightImage} className="img-fluid" width={"529.09px"} alt="" />
                                </div>
                            </div>
                        </div>
                        <div className="field bg-white">
                            <div className="mt-3">
                                <div className="text-header text-center">
                                    <img src={Logo} className="mb-2" alt="" />
                                    <h2 className="fw-semibold fs-4 mb-0">Welcome</h2>
                                </div>
                                <form className="d-block text-center" style={{ marginBottom: "6px" }} onSubmit={handleSubmit} ref={formRef}>
                                    <div className="d-flex flex-column align-items-center justify-content-center">
                                        <div className="input-container d-flex gap-2" style={{ maxWidth: "346px", width: "100%" }}>
                                            <div className="input-field w-50 w-sm-100">
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    placeholder=" "
                                                    name="first_name"
                                                    id="first_name"
                                                    value={values.first_name}
                                                    onChange={handleChange}
                                                    onBlur={handleBlur}
                                                />
                                                <label>
                                                    First Name <span className="text-danger">*</span>
                                                </label>
                                                {errors.first_name && touched.first_name && <p className="text-danger text-left f-12">{errors.first_name}</p>}
                                            </div>
                                            <div className="input-field w-50 w-sm-100">
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    placeholder=""
                                                    name="last_name"
                                                    id="last_name"
                                                    value={values.last_name}
                                                    onChange={handleChange}
                                                    onBlur={handleBlur}
                                                />
                                                <label>
                                                    Last Name <span className="text-danger">*</span>
                                                </label>
                                                {errors.last_name && touched.last_name && <p className="text-danger text-left f-12">{errors.last_name}</p>}
                                            </div>
                                        </div>
                                        <div className="input-field">
                                            <input
                                                type="text"
                                                className="form-control"
                                                placeholder=""
                                                name="user_name"
                                                id="user_name"
                                                value={values.user_name}
                                                onChange={handleChange}
                                                onBlur={handleBlur}
                                            />
                                            <label>
                                                {" "}
                                                User Name <span className="text-danger">*</span>
                                            </label>
                                            {errors.user_name && touched.user_name && <p className="text-danger text-left f-12">{errors.user_name}</p>}
                                        </div>
                                        <div className="input-field">
                                            <input
                                                type="email"
                                                className="form-control "
                                                placeholder=""
                                                name="user_email"
                                                id="user_email"
                                                value={values.user_email}
                                                onChange={handleChange}
                                                onBlur={handleBlur}
                                            />
                                            <label>
                                                Email Address <span className="text-danger">*</span>
                                            </label>
                                            {errors.user_email && touched.user_email && <p className="text-danger text-left f-12">{errors.user_email}</p>}
                                        </div>
                                        <div className="input-field">
                                            <div className="input-wrapper">
                                                <label htmlFor="phoneInput" className={values.phone ? "filled" : ""}>
                                                    Contact Number <span className="text-danger">*</span>
                                                </label>
                                                <PhoneInput
                                                    inputStyle={{ width: "100%" }}
                                                    id="phoneInput"
                                                    inputClass="phone-input"
                                                    name="phone"
                                                    countryCodeEditable={false}
                                                    country="us"
                                                    value={values.phone}
                                                    onlyCountries={["us"]}
                                                    placeholder="Contact Number"
                                                    onChange={(value, data) => {
                                                        setFieldValue("phone", value);
                                                        console.log(value);
                                                        console.log(data);
                                                    }}
                                                />
                                            </div>

                                            {errors.phone && touched.phone && <p className="text-danger text-left f-12">{errors.phone}</p>}
                                        </div>
                                        <div className="input-field">
                                            <input
                                                type={showPassword ? "text" : "password"}
                                                className="form-control"
                                                placeholder=""
                                                name="password"
                                                id="password"
                                                value={values.password}
                                                onChange={handleChange}
                                                onBlur={handleBlur}
                                                autocomplete="new-password"
                                            />

                                            <label>
                                                Password <span className="text-danger">*</span>
                                            </label>
                                            <div className="position-absolute" style={{ bottom: "13px", right: "12px" }}>
                                                <button
                                                    type="button"
                                                    onClick={togglePasswordVisibility}
                                                    className="password-toggle"
                                                    style={{
                                                        background: "none",
                                                        border: "none",
                                                        cursor: "pointer",
                                                    }} // Optional: style for better UX
                                                    dangerouslySetInnerHTML={{
                                                        __html: showPassword ? `<i class="fa-regular fa-eye-slash"></i>` : `<i class="fa-regular fa-eye"></i>`,
                                                    }}
                                                />
                                            </div>
                                            {errors.password && touched.password && <p className="text-danger text-left f-12">{errors.password}</p>}
                                        </div>
                                        <div className="input-field mb-4">
                                            <input
                                                type="text"
                                                className="form-control "
                                                placeholder=""
                                                name="referral_code"
                                                id="referral_code"
                                                value={values.referral_code}
                                                onChange={handleChange}
                                                onBlur={handleBlur}
                                            />
                                            <label>Referral Code</label>
                                            {errors.referral_code && touched.referral_code && (
                                                <p className="text-danger text-left f-12">{errors.referral_code}</p>
                                            )}
                                        </div>
                                    </div>

                                        <p className="mb-0 text-muted">
                                            <strong>Free Trial:</strong> {trial_start_date} → {trial_end_date}
                                        </p>

                                    <div className="btn-grp mt-1">
                                        <button type="submit" className="btn btn-dark submit-btn fw-semibold" disabled={isSubmitting}>
                                            Sign up
                                            {isSubmitting && <LinearProgress className="mt-2" />}
                                        </button>
                                    </div>
                                </form>
                                <div className="field-footer text-center ">
                                    <p className="fs-6 mb-0 pt-2">
                                        <Link to="/login" className="text-dark text-decoration-none">
                                            Already have an account.{" "}
                                            <Link to="/login" className="text-decoration-underline fw-bold fs-6 text-dark">
                                                Sign in
                                            </Link>
                                        </Link>
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div className="btn-cancel">
                            <Link to="/" className="fw-bold rounded-5 bg-light px-2 py-1">
                                <i class="fa-solid fa-xmark"></i>
                            </Link>
                        </div>
                    </div>
                </div>
                <style>
                    {`
          .site-sub-main{
            position:relative;
          }
          .btn-cancel{
            position:absolute;
            top:12px;
            right:12px;
          }
          .field {
            height:670px;
          }
          .input-wrapper {
            position: relative;
            width: 100%;
            
          }

          .input-wrapper label {
            position: absolute;
            top: 50%;
            left: 0.5rem;
            transform: translateY(-50%);
            background-color: white;
            padding: 0 0.25rem;
            transition: all 0.3s ease;
            color: #000;
            pointer-events: none;
            z-index: 3;
          }

          /* When input is focused or wrapper has focus, move label above */
          .input-wrapper:focus-within label,
          .input-wrapper label.filled {
            top: 0px;
            left: 0.9rem;
            font-size: 12px;
            color: #000;
          }

          /* Custom styles for PhoneInput component */
          .react-tel-input .form-control {
            height: 48px;
          }

          .react-tel-input .selected-flag:before {
            border: unset !important;
          }

          .react-tel-input .selected-flag:focus:before, 
          .react-tel-input .selected-flag.open:before {
            box-shadow: none !important;
            border: unset !important;
          }

          .react-tel-input .flag-dropdown {
            border: none !important;
            background: transparent !important;
          }

          .react-tel-input .selected-flag:hover, 
          .react-tel-input .selected-flag:focus {
            background: transparent !important;
          }

          .react-tel-input .flag-dropdown.open .selected-flag {
            background: transparent !important;
          }
        `}
                </style>
            </section>
        </>
    );
};

export default Member_Register;
